import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/student/my-channel-list`;

export const myChannelListRoutesObj = {
  list: baseRoute,
  view: `${baseRoute}/view/:channelId`,
} as const;

export type IMyChannelListRouteParams = IExtractRouteParamMap<
  typeof myChannelListRoutesObj
>;

export const myChannelListPath = createPaths<
  typeof myChannelListRoutesObj,
  IMyChannelListRouteParams
>(myChannelListRoutesObj);
